import type { EdsCategoryToggleEventPayload } from '@/features/eds/components/EdsCategories/events/types/EdsCategoryToggleEventPayload';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsCategoryToggleEvent extends EventV2<EdsCategoryToggleEventPayload> {}
